import { CountryCode } from '@gql/graphql';

export const COUNTRY_CODES_WITH_PHONE_LABELS = {
  BE: '🇧🇪 BE (+32)',
  NL: '🇳🇱 NL (+31)',
  FR: '🇫🇷 FR (+33)',
  DE: '🇩🇪 DE (+49)',
  CH: '🇨🇭 CH (+41)',
  AD: '🇦🇩 AD (+376)',
  AL: '🇦🇱 AL (+355)',
  AT: '🇦🇹 AT (+43)',
  BA: '🇧🇦 BA (+387)',
  BG: '🇧🇬 BG (+359)',
  BY: '🇧🇾 BY (+375)',
  CY: '🇨🇾 CY (+357)',
  CZ: '🇨🇿 CZ (+420)',
  DK: '🇩🇰 DK (+45)',
  EE: '🇪🇪 EE (+372)',
  ES: '🇪🇸 ES (+34)',
  FI: '🇫🇮 FI (+358)',
  GB: '🇬🇧 GB (+44)',
  GR: '🇬🇷 GR (+30)',
  HR: '🇭🇷 HR (+385)',
  HU: '🇭🇺 HU (+36)',
  IE: '🇮🇪 IE (+353)',
  IS: '🇮🇸 IS (+354)',
  IT: '🇮🇹 IT (+39)',
  LI: '🇱🇮 LI (+423)',
  LT: '🇱🇹 LT (+370)',
  LU: '🇱🇺 LU (+352)',
  LV: '🇱🇻 LV (+371)',
  MC: '🇲🇨 MC (+377)',
  MD: '🇲🇩 MD (+373)',
  ME: '🇲🇪 ME (+382)',
  MK: '🇲🇰 MK (+389)',
  MT: '🇲🇹 MT (+356)',
  NO: '🇳🇴 NO (+47)',
  PL: '🇵🇱 PL (+48)',
  PT: '🇵🇹 PT (+351)',
  RO: '🇷🇴 RO (+40)',
  RS: '🇷🇸 RS (+381)',
  RU: '🇷🇺 RU (+7)',
  SE: '🇸🇪 SE (+46)',
  SI: '🇸🇮 SI (+386)',
  SK: '🇸🇰 SK (+421)',
  UA: '🇺🇦 UA (+380)',
};

export const COUNTRY_CODES_WITH_PHONE_VALUES = {
  AD: '+376',
  AL: '+355',
  AT: '+43',
  BA: '+387',
  BE: '+32',
  BG: '+359',
  BY: '+375',
  CH: '+41',
  CY: '+357',
  CZ: '+420',
  DE: '+49',
  DK: '+45',
  EE: '+372',
  ES: '+34',
  FI: '+358',
  FR: '+33',
  GB: '+44',
  GR: '+30',
  HR: '+385',
  HU: '+36',
  IE: '+353',
  IS: '+354',
  IT: '+39',
  LI: '+423',
  LT: '+370',
  LU: '+352',
  LV: '+371',
  MC: '+377',
  MD: '+373',
  ME: '+382',
  MK: '+389',
  MT: '+356',
  NL: '+31',
  NO: '+47',
  PL: '+48',
  PT: '+351',
  RO: '+40',
  RS: '+381',
  RU: '+7',
  SE: '+46',
  SI: '+386',
  SK: '+421',
  UA: '+380',
};

export const SUPPORTED_COUNTRIES = [
  CountryCode.BE,
  CountryCode.FR,
  CountryCode.NL,
  CountryCode.CH,
  CountryCode.DE,
];
export const SUPPORTED_BUYER_COUNTRIES = [
  'BE',
  'NL',
  'FR',
  'DE',
  'CH',
  'AD',
  'AL',
  'AT',
  'BA',
  'BG',
  'BY',
  'CY',
  'CZ',
  'DK',
  'EE',
  'ES',
  'FI',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'MT',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'RU',
  'SE',
  'SI',
  'SK',
  'UA',
];
export enum SupportedPhoneNumbersEnum {
  'BE' = 'BE',
  'FR' = 'FR',
  'NL' = 'NL',
  'CH' = 'CH',
  'LU' = 'LU',
  'DE' = 'DE',
  'EU' = 'EU',
}

export const SUPPORTED_PHONE_NUMBERS = [
  SupportedPhoneNumbersEnum.BE,
  SupportedPhoneNumbersEnum.FR,
  SupportedPhoneNumbersEnum.NL,
  SupportedPhoneNumbersEnum.CH,
  SupportedPhoneNumbersEnum.DE,
  SupportedPhoneNumbersEnum.LU,
];

export const BUYER_SUPPORTED_PHONE_NUMBERS = [
  'BE',
  'NL',
  'FR',
  'DE',
  'CH',
  'AD',
  'AL',
  'AT',
  'BA',
  'BG',
  'BY',
  'CY',
  'CZ',
  'DK',
  'EE',
  'ES',
  'FI',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'MT',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'RU',
  'SE',
  'SI',
  'SK',
  'UA',
];

export const FR_SUPPORTED_REGIONS = [
  'FR_RHONE_ALPES',
  'FR_PICARDIE',
  'FR_AUVERGNE',
  'FR_ALPE_COTE_AZUR',
  'FR_CHAMPAGNE_ARDENNE',
  'FR_MIDI_PYRENEES',
  'FR_LANGUEDOC_ROUSILLON',
  'FR_BASSE_NORMANDIE',
  'FR_POITOU_CHARENTES',
  'FR_CENTRE',
  'FR_LIMOUSIN',
  'FR_BOURGOGNE',
  'FR_BRETAGNE',
  'FR_AQUITAINE',
  'FR_FRANCHE_COMTE',
  'FR_HAUTE_NORMANDIE',
  'FR_PAYS_DE_LA_LOIRE',
  'FR_LORRAINE',
  'FR_NORD_PAS_DE_CALAIS',
  'FR_ALSACE',
  'FR_ILE_DE_FRANCE',
  'FR_CORSE',
];
export const BE_SUPPORTED_REGIONS = [
  'BE_BRU',
  'BE_WAL',
  'BE_VBR',
  'BE_VAN',
  'BE_VLI',
  'BE_WLG',
  'BE_WNA',
  'BE_WHT',
  'BE_WLX',
  'BE_VWV',
  'BE_VOV',
];
export const NL_SUPPORTED_REGIONS = [
  'NL_NOORD_HOLLAND',
  'NL_FLEVOLAND',
  'NL_UTRECHT',
  'NL_ZUID_HOLLAND',
  'NL_GELDERLAND',
  'NL_NOORD_BRABANT',
  'NL_ZEELAND',
  'NL_LIMBURG',
  'NL_OVERIJSSEL',
  'NL_DRENTHE',
  'NL_GRONINGEN',
  'NL_FRIESLAND',
];

export const DE_SUPPORTED_REGIONS = [
  'DE_BW',
  'DE_BY',
  'DE_BE',
  'DE_BB',
  'DE_HB',
  'DE_HH',
  'DE_HE',
  'DE_MV',
  'DE_NI',
  'DE_NW',
  'DE_RP',
  'DE_SL',
  'DE_SN',
  'DE_ST',
  'DE_SH',
  'DE_TH',
];

export const CH_SUPPORTED_REGIONS = [
  'CH_AG',
  'CH_AR',
  'CH_AI',
  'CH_BL',
  'CH_BS',
  'CH_BE',
  'CH_FR',
  'CH_GE',
  'CH_GL',
  'CH_GR',
  'CH_JU',
  'CH_LU',
  'CH_NE',
  'CH_NW',
  'CH_OW',
  'CH_SG',
  'CH_SH',
  'CH_SZ',
  'CH_SO',
  'CH_TG',
  'CH_TI',
  'CH_UR',
  'CH_VS',
  'CH_VD',
  'CH_ZG',
  'CH_ZH',
];

export const SUPPORTED_REGIONS = {
  [CountryCode.BE]: BE_SUPPORTED_REGIONS,
  [CountryCode.NL]: NL_SUPPORTED_REGIONS,
  [CountryCode.FR]: FR_SUPPORTED_REGIONS,
  [CountryCode.DE]: DE_SUPPORTED_REGIONS,
  [CountryCode.CH]: CH_SUPPORTED_REGIONS,
  [CountryCode.EU]: [
    ...BE_SUPPORTED_REGIONS,
    ...NL_SUPPORTED_REGIONS,
    ...FR_SUPPORTED_REGIONS,
    ...DE_SUPPORTED_REGIONS,
    ...CH_SUPPORTED_REGIONS,
  ],
  [CountryCode.CA]: [],
};
